module.exports = __webpack_public_path__ + "static/media/bigGrid.082a267d.png";